<template>
  <div class="articles-list-cities-all">
    <ul class="articles-list-cities-all-list">
      <li
        v-for="(city, i) in sortCountries"
        :key="i"
        class="articles-list-cities-all-list-item"
      >
        <span class="articles-list-cities-all-list-title">
          {{ city.letter }}
        </span>
        <div class="articles-list-cities-all-list-items">
          <a
            v-for="(children, i) in city.children"
            :key="i"
            class="blue-link articles-list-cities-all-link"
            :href="goTo(children.slug)"
            @click.prevent="use(children)"
          >
            {{ children.nameRu }}
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
  import sortBy from 'lodash-es/sortBy';
  import unionBy from 'lodash-es/unionBy';
  import { computed } from 'vue';
  import type { GeoItem } from '@/shared/models/journal';

  const emit = defineEmits<{
    /**
     * Событие клика по элементу.
     *
     * @param item данные элемента
     * @param position позиция в списке
     */
    'item-click': [el: GeoItem, url: string];
  }>();

  const props = defineProps<{
    countries: GeoItem[];
    linkType: 'country' | 'city' | 'region';
  }>();

  const sortCountries = computed(() => {
    const sortByName = sortBy(props.countries, 'nameRu');

    const mapLetter = sortByName.map((el) => ({
      letter: el.nameRu[0].toUpperCase(),
    }));

    return unionBy(mapLetter, 'letter').map((item) => {
      const children = sortByName.filter((city) => city.nameRu[0].toUpperCase() === item.letter);
      return {
        ...item,
        children,
      };
    });
  });

  const goTo = (slug: string): string => {
    if (props.linkType === 'city' || props.linkType === 'region') {
      return `/journal/city/articles/${slug}/`;
    }

    if (props.linkType === 'country') {
      return `/journal/country/articles/${slug}/`;
    }

    return '';
  };

  const use = (el: GeoItem) => {
    emit('item-click', el, goTo(el.slug));
  };
</script>

<style lang="scss" scoped>
  .articles-list-cities-all {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    width: 100%;
  }

  .articles-list-cities-all-title {
    width: 100%;
    margin-bottom: 16px;
    font-weight: 800;
    font-size: 17px;
    line-height: 24px;
  }

  .articles-list-cities-all-list-title {
    width: 20px;
    margin-right: 16px;
    font-weight: 800;
    font-size: 17px;
    line-height: 24px;
  }

  .articles-list-cities-all-list {
    width: 100%;
    column-count: 4;

    @include tablet {
      column-count: 2;
    }

    @include mobile {
      column-count: 1;
    }
  }

  .articles-list-cities-all-list-item {
    display: flex;
  }

  .articles-list-cities-all-list-items {
    display: flex;
    flex-direction: column;

    @include mobile {
      width: 100%;
    }
  }

  .articles-list-cities-all-link {
    margin-bottom: 16px;
    font-size: 17px;
    line-height: 24px;

    &:hover {
      color: var(--alias-color-link-default-hovered);
    }
  }
</style>
